export default __webpack_public_path__ + "static/media/baseline-place-24px.2f342a18.svg";